//
//
//
//
//
//

export default {
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number
  },
  watch: {
    value (newValue) {
      this.currentValue = newValue
      this.$emit('on-change', newValue)
    },
    currentValue (val) {
      this.$emit('input', val)
    }
  },
  data () {
    return {
      currentValue: this.value
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/checker/checker.vue